export enum AccountingCalendarEnum {
    P12 = 1,
    P13 = 2,
    P445 = 3,
    P454 = 4,
    P544 = 5
}
